import React from "react";

const PageContentWrapper = (props) => {
  return <div className={"page-wrapper"}>{props.children}</div>;
};

export default PageContentWrapper;
